export const API_ROOT = window.__env.API_ROOT
export const SOCKET_SERVER = window.__env.SOCKET_SERVER
export const BASE_URL = window.__env.BASE_URL
export const URL_COOKIES_POLICY = window.__env.URL_COOKIES_POLICY
export const URL_PRIVACY_POLICY = window.__env.URL_PRIVACY_POLICY
export const APP_SERVICE_ID = window.__env.APP_SERVICE_ID
export const COOKIE_MODAL_ID = window.__env.COOKIE_MODAL_ID
